import { render, staticRenderFns } from "./bike.vue?vue&type=template&id=6f4e1391&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PackagesTargetedRange: require('/usr/src/motec/components/packages/TargetedRange.vue').default})
